import { createContext } from "react";

import { ApiStore } from "./ApiStore";
import { NavigationStore } from "./NavigationStore";
import { UserStore } from "./UserStore";

const apiStore = new ApiStore();
const userStore = new UserStore(apiStore);
const navigationStore = new NavigationStore(userStore);

export const ApiContext = createContext(apiStore);
export const UserContext = createContext(userStore);
export const NavigationContext = createContext(navigationStore);
